import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CS325BBB from './Panels/cs325bbb';
import PAN330AC from './Panels/pan330ac';
import HAN340 from './Panels/han340';
import HYU395S from './Panels/hyu395s';
import HYU400S from './Panels/hyu400s';
import AX320 from './Panels/ax320';
import LG400BIF from './Panels/lg400bif';
import LG350W from './Panels/lg350W';
import LG360W from './Panels/lg360W';
import SOLARIA360 from './Panels/solaria360';
import REC365 from './Panels/rec365';
import SolarEdge from './Inverters/solaredge';
import Generac from './Inverters/generac';
import Enphase from './Inverters/enphase';
import SOLARK from './Inverters/solark';
import NEPRS from './ModuleLevel/NEPRS';
import MiscEquipment from './MISC/MISC';
import Fronius from './Inverters/fronius';
import SMA from './Inverters/sma';
import WGYB from './MISC/WGYB';


const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '100%',
        flexShrink: 0,
        textTransform: 'capitalize',
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
});

class SystemSpecsPanels extends React.Component {
  state = {
      expanded: null,
  };

  handleChange = panel => (event, expanded) => {
      this.setState({
          expanded: expanded ? panel : false,
      });
  };


  render() {
      const { classes, terms } = this.props;
      const { expanded } = this.state;

      let panel = 'With our team of engineers, Solvana picks the best panel for your project. We consider factors like value, product availability, temperature, proximity to salt water, wind, available space, height of the array, and many other factors when picking your panel. Ask us for more information about your panel and we will send you all of the specs and the reason for our choice.';

      let panelName = 'Solar Panels';
      if (terms.solarPanel === 'cs325bbb') {
          panelName = '325W Canadian Solar (SC1H-325MS)';
      } else if (terms.solarPanel === 'ax320') {
          panelName = 'Axitec 320W All Black Module - German Brand';
      } else if (terms.solarPanel === 'han340') {
          panelName = '340W Hanwha Q.PEAK DUO BLACK G6 ';
      } else if (terms.solarPanel === 'hyu395s') {
          panelName = '395W Hyundai Commercial Solar Panels';
      } else if (terms.solarPanel === 'hyu400s') {
          panelName = '400W Hyundai Commercial Solar Panels';
      } else if (terms.solarPanel === 'lg400bif') {
          panelName = '400W Premium LG Bifacial Solar Panels ';
      } else if (terms.solarPanel === 'pan330ac') {
          panelName = '330W Panasonic HIT® AC Series Advantage';
      } else if (terms.solarPanel === 'lg350W') {
          panelName = '350W LG NeON® 2';
      } else if (terms.solarPanel === 'lg360W') {
          panelName = '360W LG Solar’s NeON® R';
      } else if (terms.solarPanel === 'Solaria_360') {
          panelName = '360W Solaria POWERXT-360R-PD';
      } else if (terms.solarPanel === 'rec365') {
          panelName = 'REC ALPHA 365 Premium All Black';
      }
      let inverterName = 'Inverter';
      if (terms.inverter === 'solaredge') {
          inverterName = 'SolarEdge Inverter with Optimizers';
      } else if (terms.inverter === 'generac') {
          inverterName = 'Generac Inverter';
      } else if (terms.inverter === 'fronius') {
          inverterName = 'Fronius International GmbH';
      } else if (terms.inverter === 'sma') {
          inverterName = 'SMA Solar Inverter';
      } else if (terms.inverter === 'enphase') {
          inverterName = 'Enphase Mciro Inverter';
      } else if (terms.inverter === 'solark') {
          inverterName = 'SolArk Inverter';
      }


      if (terms.solarPanel === 'cs325bbb') {
          panel =
              <CS325BBB />;
      } else if (terms.solarPanel === 'ax320') {
          panel = <AX320 />;
      } else if (terms.solarPanel === 'pan330ac') {
          panel = <PAN330AC />;
      } else if (terms.solarPanel === 'han340') {
          panel = <HAN340 />;
      } else if (terms.solarPanel === 'hyu395s') {
          panel = <HYU395S />;
      } else if (terms.solarPanel === 'hyu400s') {
          panel = <HYU400S />;
      } else if (terms.solarPanel === 'lg350W') {
          panel = <LG350W />;
      } else if (terms.solarPanel === 'lg400bif') {
          panel = <LG400BIF />;
      } else if (terms.solarPanel === 'lg360W') {
          panel = <LG360W />;
      } else if (terms.solarPanel === 'solaria360') {
          panel = <SOLARIA360 />;
      } else if (terms.solarPanel === 'rec365') {
          panel = <REC365 />;
      }


      let inverter = 'With our team of engineers, Solvana picks the best inverter for your project. We consider factors like value, product availability, temperature, shading, size of arrays, batteries and many other factors when picking your panel. Ask us for more information about your inverter and we will send you all of the specs and the reason for our choice.';


      if (terms.inverter === 'solaredge') {
          inverter = <SolarEdge terms={terms} />;
      } else if (terms.inverter === 'generac') {
          inverter = <Generac />;
      } else if (terms.inverter === 'enphase') {
          inverter = <Enphase resiToggle={terms.resiToggle} />;
      } else if (terms.inverter === 'fronius') {
          inverter = <Fronius />;
      } else if (terms.inverter === 'sma') {
          inverter = <SMA terms={terms} />;
      } else if (terms.inverter === 'solark') {
          inverter = <SOLARK />;
      }

      return (
          <div className={classes.root}>
              <ExpansionPanel expanded={expanded === 'panel34'} onChange={this.handleChange('panel34')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>Solvana Has Your Back</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography>
                        <WGYB />
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>{panelName}</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography>
                          {panel}
                          &nbsp;
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>{inverterName}</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography>
                          {inverter}
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              {terms.inverter === 'solark' ?
                  <ExpansionPanel expanded={expanded === 'panel233'} onChange={this.handleChange('panel233')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                              NEP Monitoring and Safety
                          </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography>
                              <NEPRS />
                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null}
              {terms.systemNotes ?
                  <ExpansionPanel expanded={expanded === 'panel31'} onChange={this.handleChange('panel31')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                              System Notes & Miscelleneous Equipment
                          </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <MiscEquipment systemNotes={terms.systemNotes} />
                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
          </div>
      );
  }
}

SystemSpecsPanels.propTypes = {
    classes: PropTypes.object.isRequired,
    terms: PropTypes.object.isRequired,
};

export default withStyles(styles)(SystemSpecsPanels);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/systemSpecsPanels.js